import { SET_HAS_LANGUAGE } from '../actions/hasLanguageDataActions';

let initialState = false;

const hasLanguageDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_LANGUAGE:
            return action.payload.value
        default:
            return state;
    }
}

export default hasLanguageDataReducer;